var React = require('react');

function CheckMedium (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 16.7273L15.7778 25L28 12","stroke":"#2665F6","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round"}));
}

CheckMedium.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = CheckMedium;

CheckMedium.default = CheckMedium;
